import axios from 'axios';

let base;
if (window.location.hostname === 'localhost') {
  base = 'http://localhost:5000/api/v1';
} else if (window.location.hostname === 'pre-prod.assistance-voyage.axa.nc') {
  base = "https://pre-prod.assistance-voyage.axa.nc/api/v1"
} else if (window.location.hostname === 'assistance-voyage.axa.nc') {
  base = "https://assistance-voyage.axa.nc/api/v1"
} else {
  // Valeur par défaut pour le développement local ou autre cas
  base = 'http://localhost:5000/api/v1';
}

const PrivateAxios = axios.create({
  baseURL: base,
  timeout: 15000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Fonction pour récupérer le CSRF token
async function getCsrfToken() {
  try {
    const response = await axios.get(`${base}/get-csrf`, { withCredentials: true });
    return response.data.token;
  } catch (error) {
    console.error('Erreur lors de la récupération du CSRF token', error);
    throw error;
  }
}

// Interceptor pour gérer les requêtes PUT, POST, DELETE, OPTIONS
PrivateAxios.interceptors.request.use(async (config) => {
  const methodsRequiringCsrf = ['PUT', 'POST', 'DELETE', 'OPTIONS'];

  // Vérifie si la méthode de la requête nécessite un CSRF token
  if (methodsRequiringCsrf.includes(config.method.toUpperCase())) {
    try {
      const csrfToken = await getCsrfToken();
      config.headers['X-CSRFToken'] = csrfToken;
    } catch (error) {
      // Gérer l'erreur si nécessaire
      console.error('Impossible d’ajouter le CSRF token', error);
      return Promise.reject(error);
    }
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// Endpoints d'authentification dont les 401 sont "légitimes" (mauvais identifiants,
// code 2FA erroné/expiré, session 2FA expirée) : ils sont gérés par le composant Login
// et ne doivent PAS déclencher la redirection automatique vers /login.
const AUTH_ENDPOINTS = ['/login', '/login/verify-2fa', '/login/resend-2fa'];

// Interceptor pour gérer les retours de requêtes code error 401 et redirigé vers la page de reconnexion
PrivateAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    const isAuthEndpoint = AUTH_ENDPOINTS.some((path) => requestUrl === path);

    if (error.response && error.response.status === 401 && !isAuthEndpoint) {
      console.error('Erreur 401 : Non autorisé, déconnexion de l\'utilisateur.');
      // Supprimer le token local
      localStorage.removeItem('assistance-axa-token');
      // Stocker le message dans le localStorage avant de rediriger
      localStorage.setItem('logoutMessage', 'Votre session a expiré. Veuillez vous reconnecter.');
      // Rediriger vers la page de login avec window.location.href
      window.location.href = '/login';
    }
    else if (error.response && error.response.status === 403) {
      const message = error.response.data?.message || '';
      // Révocation de session à distance : connecté ailleurs OU session > 12 h.
      // Le backend renvoie un 403 dont le message contient "Session" dans ces deux cas.
      if (message.includes('Session')) {
        // Purger l'état local
        localStorage.removeItem('assistance-axa-token');
        // Adapter le message affiché selon le motif (révocation vs expiration)
        const logoutMessage = /révoqu/i.test(message)
          ? 'Votre compte a été utilisé sur un autre appareil. Veuillez vous reconnecter.'
          : 'Votre session a expiré. Veuillez vous reconnecter.';
        localStorage.setItem('logoutMessage', logoutMessage);
        // Rediriger vers la page de login
        window.location.href = '/login';
      } else {
        console.log(error);
      }
    }
    return Promise.reject(error);
  }
);

export { PrivateAxios };
